<script>
import InputCheckbox from '@/components/atoms/inputlib/components/InputCheckbox'
import Dropdown from '@/components/atoms/Dropdown'
import Filters from '@/modules/mixins/filters'
import { mapGetters } from 'vuex'
export default {
    name: 'GeneralTagBox',
    components: { Dropdown, InputCheckbox },
    mixins: [Filters],
    props: {
        disabled: Boolean,
    },
    computed: {
        ...mapGetters({
            smDevice: 'smDevice',
            restaurantFilters: 'site/restaurantFilters',
            currency: 'site/currency',
        }),
        favourite: {
            get() {
                return Boolean(this.$route.query.user_favorite)
            },
            set(val) {
                this.setQuery(
                    {
                        [this.filters.find((filter) => filter.model === 'favourite')?.key]: val
                            ? val
                            : undefined,
                    },
                    'restaurant-list'
                )
            },
        },
        alreadyOrdered: {
            get() {
                return Boolean(this.$route.query.already_ordered_from)
            },
            set(val) {
                this.setQuery(
                    {
                        [this.filters.find((filter) => filter.model === 'alreadyOrdered')?.key]: val
                            ? val
                            : undefined,
                    },
                    'restaurant-list'
                )
            },
        },
        maxDeliveryTime: {
            get() {
                return Boolean(this.$route.query.max_delivery_time)
            },
            set(val) {
                this.setQuery(
                    {
                        [this.filters.find((filter) => filter.model === 'maxDeliveryTime')?.key]:
                            val ? this.restaurantFilters?.max_delivery_time : undefined,
                    },
                    'restaurant-list'
                )
            },
        },
        maxDeliveryPrice: {
            get() {
                return Boolean(this.$route.query.max_delivery_price)
            },
            set(val) {
                this.setQuery(
                    {
                        [this.filters.find((filter) => filter.model === 'maxDeliveryPrice')?.key]:
                            val ? this.restaurantFilters?.max_delivery_price : undefined,
                    },
                    'restaurant-list'
                )
            },
        },
    },
    methods: {
        getParameter(filter) {
            return this[filter]
        },
        setParameter(filter, val) {
            this.$set(this, filter, val)
        },
    },
}
</script>

<template lang="pug">
    .tag-box
        .px-6
            input-checkbox.w-100.my-2.py-1(
                v-for="(filter, index) in filters"
                v-if="!filter.hide"
                :key="`generalFilter-${index}`"
                :value="getParameter(filter.model)"
                :disabled="disabled"
                @input="setParameter(filter.model, $event)") {{filter.label}}
</template>
